import React from 'react';

interface RightTwoArrowCircleProps {
  height: number;
  width: number;
}

const MessagesIcon: React.FC<RightTwoArrowCircleProps> = ({
  width,
  height,
}) => {
  return (
    <svg
      width={width.toString()}
      height={height.toString()}
      viewBox={`0 0 ${width.toString()} ${height.toString()}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex justify-center items-center"
    >
      <mask
        id="mask0_181897_22799"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g
        mask="url(#mask0_181897_22799)"
        transform={`translate(${(width - 20) / 2}, ${(height - 20) / 2})`}
      >
        <path
          d="M18.3332 18.3333L14.9998 15H6.6665C6.20817 15 5.81581 14.8368 5.48942 14.5104C5.16303 14.184 4.99984 13.7916 4.99984 13.3333V12.5H14.1665C14.6248 12.5 15.0172 12.3368 15.3436 12.0104C15.67 11.684 15.8332 11.2916 15.8332 10.8333V4.99996H16.6665C17.1248 4.99996 17.5172 5.16315 17.8436 5.48954C18.17 5.81593 18.3332 6.20829 18.3332 6.66663V18.3333ZM3.33317 10.1458L4.31234 9.16663H12.4998V3.33329H3.33317V10.1458ZM1.6665 14.1666V3.33329C1.6665 2.87496 1.8297 2.4826 2.15609 2.15621C2.48248 1.82982 2.87484 1.66663 3.33317 1.66663H12.4998C12.9582 1.66663 13.3505 1.82982 13.6769 2.15621C14.0033 2.4826 14.1665 2.87496 14.1665 3.33329V9.16663C14.1665 9.62496 14.0033 10.0173 13.6769 10.3437C13.3505 10.6701 12.9582 10.8333 12.4998 10.8333H4.99984L1.6665 14.1666Z"
          fill="#003568"
        />
      </g>
    </svg>
  );
};

export default MessagesIcon;
